import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { Project } from 'app/models/project';
import { ApplicationStatus } from 'app/models/application';
import { ApplicationsService } from 'app/services/applications.service';
import { Alert } from 'app/shared/alerts/simple-message/simple-message.component';
import { SessionStorage } from 'app/storage/session.storage';
import { Logger } from 'app/utilities/logger';
import { catchError, EMPTY } from 'rxjs';

@Component({
  selector: 'project-sopcard-small',
  templateUrl: './project-sopcard-small.component.html',
  styleUrls: ['../epe-sopcard-small/epe-sopcard-small.component.scss', '../sopcard.component.scss']
})
export class ProjectSopcardSmallComponent implements OnInit, AfterViewInit {

  @Input() project!: Project;

  checked = false;
  note = '';

  showAlert = false;
  alertMessage = '';
  alertType: Alert = Alert.SUCCESS;

  constructor(
    private applicationsService: ApplicationsService,
    public auth: SessionStorage,
    private logger: Logger,
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    if (!this.project.sop_status) this.project.sop_status = 'pending';
    if (this.project.sop_status !== 'pending' && (this.auth.isCallManager() || this.auth.isProjectBoard())) {
      this.loadNote();
    }
  }

  private get appId(): string {
    const id = (this.project as any)._id;
    if (!id) return '';
    if (typeof id === 'object' && id['$oid']) return id['$oid'];
    return String(id);
  }

  private get userId(): number {
    return (this.project as any).user_id ?? this.project.id ?? 0;
  }

  private loadNote(): void {
    if (!this.appId) return;
    this.applicationsService.getNote(this.appId).pipe(
      catchError(() => EMPTY)
    ).subscribe(note => { this.note = note; });
  }

  change(): void {
    this.checked = !this.checked;
  }

  submitEligibility(): void {
    const status: ApplicationStatus = this.checked ? 'eligible' : 'not_eligible';
    this.applicationsService.updateStatus(this.appId, status, this.userId).pipe(
      catchError(err => {
        this.addAlert('Eligibility check failed. Please contact the administrator.', Alert.ERROR);
        return EMPTY;
      })
    ).subscribe(() => {
      this.project.sop_status = status;
      (this.project as any).status = status;
      this.addAlert('Eligibility check done.', Alert.SUCCESS);
      this.loadNote();
    });
  }

  moveProjectToProActive(): void {
    this.applicationsService.updateStatus(this.appId, 'proactive', this.userId).pipe(
      catchError(() => {
        this.addAlert('Move to ProActive failed. Please contact the administrator.', Alert.ERROR);
        return EMPTY;
      })
    ).subscribe(() => {
      this.project.sop_status = 'proactive';
      (this.project as any).status = 'proactive';
      this.addAlert('Project moved to ProActive.', Alert.SUCCESS);
    });
  }

  moveProjectToEligible(): void {
    this.applicationsService.updateStatus(this.appId, 'eligible', this.userId).pipe(
      catchError(() => {
        this.addAlert('Move to Eligible failed. Please contact the administrator.', Alert.ERROR);
        return EMPTY;
      })
    ).subscribe(() => {
      this.project.sop_status = 'eligible';
      (this.project as any).status = 'eligible';
      this.addAlert('Project moved back to Eligible.', Alert.SUCCESS);
    });
  }

  submitNote(): void {
    this.applicationsService.updateNote(this.appId, this.note).pipe(
      catchError(() => {
        this.addAlert('Note save failed. Please contact the administrator.', Alert.ERROR);
        return EMPTY;
      })
    ).subscribe(() => {
      this.addAlert('Note saved.', Alert.SUCCESS);
    });
  }

  addAlert(message: string, type: Alert): void {
    this.alertMessage = message;
    this.alertType = type;
    this.showAlert = true;
  }
}
